/* eslint no-self-compare: 0 */
import "./polyfills";

import "pobble-components/dist/setup/sentry";
import "pobble-components/dist/setup/external-tools";

import React from "react";
import { ThemeProvider, JssProvider } from "react-jss";

import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";

import SearchApp from "./components/search/SearchApp";

import { UserProvider } from "pobble-components/dist/pobble-user";
import theme from "pobble-components/dist/theme";
import API from "./components/api";
import { CSSVars } from "pobble-components/dist/styles";

const createGenerateId = () => {
  let counter = 0;
  return (rule) => `jss-${rule.key}-${counter++}`;
};

const render = ({ me, meError }) => {
  ReactDOM.render(
    <UserProvider
      fetchMe={() => (me ? Promise.resolve(me) : Promise.reject(meError))}
    >
      <JssProvider generateClassName={createGenerateId()}>
        <ThemeProvider theme={theme}>
          <CSSVars>
            <SearchApp />
          </CSSVars>
        </ThemeProvider>
      </JssProvider>
    </UserProvider>,
    document.getElementById("root")
  );
};

const run = ({ me, meError }) => {
  ["complete", "loaded", "interactive"].indexOf(document.readyState) >= 0 &&
  document.body
    ? render({ me, meError })
    : window.addEventListener(
        "DOMContentLoaded",
        () => render({ me, meError }),
        false
      );
};

API.get(
  "/v3/me?include=account.timestamps,account.email_identity.email,account.subscriptions,account.subscription_policy,account.names,account.policy,account.finish_signup_status,account.student_type,account.student_type.school,account.avatar,account.pending_teacher_type,account.pending_teacher_type.details,account.pending_teacher_type.school,account.teacher_type,account.teacher_type.school,account.followed_schools,account.school.names,account.school.logo"
).then(
  (res) => run({ me: res }),
  (e) => run({ meError: e })
);



// WEBPACK FOOTER //
// ./search.js